import {
  TIEOUT_SYNCSCROLL_SOURCEID,
  TIEOUT_SYNCSCROLL_TARGETID,
} from 'constants/feature/statement-content-constants';
import BaseModel from 'models/base-model';

export default class SyncScrollIds extends BaseModel({
  sourceId: null,
  targetId: null,
}) {
  get syncScrollIds() {
    return this;
  }

  clearSourceId() {
    sessionStorage.setItem(TIEOUT_SYNCSCROLL_SOURCEID, null);
    return this.merge({
      sourceId: null,
    });
  }

  setSourceId(val) {
    sessionStorage.setItem(TIEOUT_SYNCSCROLL_SOURCEID, val);
    return this.merge({
      sourceId: val,
    });
  }

  setTargetId(val) {
    sessionStorage.setItem(TIEOUT_SYNCSCROLL_TARGETID, val);
    return this.merge({
      targetId: val,
    });
  }
}
